import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();

  constructor(
    private sanitizer: DomSanitizer
  ) { }
  ngOnInit() {
  }

  sanitizeSvg(svg: string) {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  socialLinksList = [
    {
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="20.952" height="20.827" viewBox="0 0 20.952 20.827" aria-label="Facebook logo" role="img">
          <g id="_icon_logo_facebook_" data-name="🦆 icon &quot;logo facebook&quot;" style="mix-blend-mode: normal;isolation: isolate">
            <path id="Vector" d="M10.476,0A10.477,10.477,0,0,0,8.839,20.826v-7.32H6.179V10.476H8.839V8.168c0-2.625,1.564-4.076,3.957-4.076a16.1,16.1,0,0,1,2.345.2V6.875H13.82a1.515,1.515,0,0,0-1.708,1.637v1.964h2.905l-.464,3.029H12.113v7.321A10.478,10.478,0,0,0,10.476,0Z" transform="translate(0 0)" fill="#788495" style="mix-blend-mode: normal;isolation: isolate"/>
          </g>
        </svg>
      `),
      title: 'Facebook',
      link: 'https://www.facebook.com/revenued/'
    },
    {
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="20.827" height="20.827" viewBox="0 0 20.827 20.827" aria-label="LinkedIn logo" role="img">
        <g id="_icon_logo_linkedin_" data-name="🦆 icon &quot;logo linkedin&quot;" style="mix-blend-mode: normal;isolation: isolate">
          <path id="Vector" d="M1.78,0A1.7,1.7,0,0,0,0,1.622v17.42a1.832,1.832,0,0,0,1.78,1.785H19.156a1.74,1.74,0,0,0,1.671-1.785V1.622A1.6,1.6,0,0,0,19.161,0ZM3.472,17.36V8.083H6.456V17.36ZM5.046,6.673a1.531,1.531,0,0,1-1.573-1.6,1.54,1.54,0,0,1,1.611-1.6,1.537,1.537,0,0,1,1.6,1.6,1.541,1.541,0,0,1-1.611,1.6ZM14.376,17.36V12.288c0-1.215-.434-2.045-1.514-2.045a1.631,1.631,0,0,0-1.53,1.1,2.01,2.01,0,0,0-.1.733V17.36H8.246V8.083H11.23V9.374A3.021,3.021,0,0,1,13.92,7.866c1.959,0,3.44,1.291,3.44,4.074v5.42Z" fill="#788495" style="mix-blend-mode: normal;isolation: isolate"/>
        </g>
      </svg>
      `),
      title: 'LinkedIn',
      link: 'https://www.linkedin.com/company/revenued'
    },
    {
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="20.827" height="20.827" viewBox="0 0 20.827 20.827" aria-label="Instagram logo" role="img">
        <g id="_icon_logo_instagram_" data-name="🦆 icon &quot;logo instagram&quot;" style="mix-blend-mode: normal;isolation: isolate">
          <path id="Vector" d="M17.816,3.01a4.352,4.352,0,0,1,1.275,3.064v8.677a4.352,4.352,0,0,1-4.339,4.339H6.075a4.352,4.352,0,0,1-4.339-4.339V6.075A4.352,4.352,0,0,1,6.075,1.735h8.677A4.352,4.352,0,0,1,17.816,3.01ZM6.075,0A6.092,6.092,0,0,0,0,6.075v8.677a6.092,6.092,0,0,0,6.075,6.075h8.677a6.092,6.092,0,0,0,6.075-6.075V6.075A6.092,6.092,0,0,0,14.752,0Z" fill="#788495" style="mix-blend-mode: normal;isolation: isolate"/>
          <path id="Vector-2" data-name="Vector" d="M.578,2.384A1.306,1.306,0,1,1,1.3,2.6,1.3,1.3,0,0,1,.578,2.384Z" transform="translate(14.751 3.471)" fill="#788495" style="mix-blend-mode: normal;isolation: isolate"/>
          <path id="Vector-3" data-name="Vector" d="M7.135,2.32a3.468,3.468,0,1,1-1.929-.585A3.471,3.471,0,0,1,7.135,2.32ZM2.314.877A5.207,5.207,0,1,0,5.207,0,5.207,5.207,0,0,0,2.314.877Z" transform="translate(5.207 5.207)" fill="#788495" style="mix-blend-mode: normal;isolation: isolate"/>
        </g>
      </svg>
      `),
      title: 'Instagram',
      link: 'https://www.instagram.com/revenuedcard/'
    },
    {
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" 
        image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 462.799" aria-label="Twitter logo" role="img">
        <path fill-rule="nonzero"   fill="#788495"
        d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"/></svg>
      `),
      title: 'Twitter',
      link: 'https://twitter.com/revenuedcard'
    }
  ];
}
